import React from 'react';
import { AddIcon } from '@/assets/icons/button';

interface AddContentButtonProps {
  /**
   * Text to display in the button
   */
  text: string;
  /**
   * Click handler
   */
  onClick: (e: React.MouseEvent) => void;
  /**
   * Whether the button should take full width. Defaults to true.
   */
  fullWidth?: boolean;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * Reusable styled button for adding content (units, subunits, activities).
 * Provides consistent styling across the course management interface.
 */
export default function AddContentButton({
  text,
  onClick,
  fullWidth = true,
  className = '',
}: AddContentButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center gap-2 px-4 py-3 bg-[color-mix(in_srgb,var(--color-brand-highlight)_13%,var(--surface-white))] border border-dashed border-primary_highlight rounded-lg text-primary hover:bg-[color-mix(in_srgb,var(--color-brand-highlight)_38%,var(--surface-white))] hover:border-[color-mix(in_srgb,var(--color-brand-highlight)_38%,var(--surface-white))] transition-colors ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      <AddIcon className='w-4 h-4' />
      <span className='text-sm text-primary font-semibold'>{text}</span>
    </button>
  );
}
